import { useT } from '@/i18n'

/** Trend oynasi tanlagichi (kun) — analitika ekranlari uchun (PageHeader `actions`да). */
export function DaysSelect({
  value,
  onChange,
  options = [14, 30, 90],
}: {
  value: number
  onChange: (d: number) => void
  options?: number[]
}) {
  const t = useT()
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      title={t.table.filters}
      className="rounded-md border border-border-default bg-surface-2 px-2 py-1 text-sm text-secondary"
    >
      {options.map((d) => (
        <option key={d} value={d}>
          {t.analytics.daysLabel(d)}
        </option>
      ))}
    </select>
  )
}
